// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentOverviewItem_content__1Ybpx","label":"ContentOverviewItem_label__1DoWn","text":"ContentOverviewItem_text__1n9wy","sending":"ContentOverviewItem_sending__34GY-"};